import { LoanApplicationTabRouteParam } from 'constants/loanApplication';

import { AlertSeverity } from './CommandCenterHome.constants';

// Maps the backend action-item severity strings onto the homepage AlertSeverity
// enum that drives the row color + urgency border. Unknown values fall through
// to INFORMATIONAL at the call site.
export const ACTION_ITEM_SEVERITY_BY_API = {
  ACTION_REQUIRED: AlertSeverity.ACTION_REQUIRED,
  HEADS_UP: AlertSeverity.HEADS_UP,
  INFORMATIONAL: AlertSeverity.INFORMATIONAL,
  HIGH: AlertSeverity.ACTION_REQUIRED,
  MEDIUM: AlertSeverity.HEADS_UP,
  LOW: AlertSeverity.INFORMATIONAL,
};

export const ACTION_ITEM_URGENCY_RANK = {
  [AlertSeverity.ACTION_REQUIRED]: 0,
  [AlertSeverity.HEADS_UP]: 1,
  [AlertSeverity.INFORMATIONAL]: 2,
};

export const LOCK_EXPIRY_CATEGORY = 'LOCK_EXPIRY';

// The typed action-item categories the broker action-items endpoint emits
// (Skynet.Loans BrokerActionCategory, DEV-3636 — serialized as the enum name via
// the API's StringEnumConverter). LOCK_EXPIRY is the separate FE-synthesized value
// the lock-expiry endpoint feeds in (see mapLockToActionItem); the wire LockExpiry
// is the same concept arriving through the action-items endpoint.
export const ActionItemCategory = {
  CONDITION: 'Condition',
  MISSING_DOC: 'MissingDoc',
  E_SIGN: 'ESign',
  LOCK_EXPIRY: 'LockExpiry',
  ACTION: 'Action',
};

// DEV-4168: deep-link an action item to the loan-management tab matching its
// category. Only categories with a verified main-tab slug are mapped; everything
// else (ESign, the generic Action bucket, the synthesized LOCK_EXPIRY) is omitted
// so the deep-link falls back to the default-tab landing — a wrong slug 404s,
// which is worse than the default. The lock categories intentionally both resolve
// to the Lock Info tab. Slugs are derived from the route taxonomy
// (LoanApplicationTabRouteParam), never hardcoded, so a tab rename can't drift.
export const ACTION_ITEM_CATEGORY_TO_TAB = {
  [ActionItemCategory.CONDITION]: LoanApplicationTabRouteParam.CONDITIONS,
  [ActionItemCategory.MISSING_DOC]: LoanApplicationTabRouteParam.DOCUMENTS,
  [ActionItemCategory.LOCK_EXPIRY]: LoanApplicationTabRouteParam.LOCK_INFO,
  [LOCK_EXPIRY_CATEGORY]: LoanApplicationTabRouteParam.LOCK_INFO,
};

export const ACTION_ITEMS_FRESHNESS_PREFIX = 'Sorted by urgency · as of';

export const ACTION_ITEMS_PII_NOTE = 'borrower name masked to last name + loan last-4';
